<div *ngIf="irisModalRef?.config?.data?.isOpened == true">
    <h2>{{irisModalRef?.config?.data?.titleText}}</h2>
    <p>
      {{irisModalRef?.config?.data?.bodyText}}
    </p>
    <iris-button-container [alignment]="buttonAlignmentOptions.END">
      <iris-button (click)="irisModalRef.close(true)">OK</iris-button>
    </iris-button-container>
</div>
